import axios from 'axios'
import url from './base-url';
import service from '../utils/service';
const api = axios.create({
    baseURL: url
});
function Headers(auth){
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export  const validateAddress = (userId,payload,auth) => api.post(`/shipments/isValidAddress/${userId}`,payload,Headers(auth));
export const calculateRate = (userId,payload,auth) => api.post(`/shipments/calculate-rate/${userId}`, payload,Headers(auth));
export const getOAuth = (carrier,userId,carrierName,auth) => api.get(`/shipments/oauth/${carrier}/${userId}/${carrierName}`,Headers(auth));
export const markAsShipped = (userId, payload,auth) =>api.post(`/shipments/markAsShipped/${userId}`, payload,Headers(auth));
export const markAsPaid = (userId, payload,auth) => api.post(`/shipments/markAsPaid/${userId}`, payload,Headers(auth));
export const markAsOnHold = (userId, payload,auth) => api.post(`/shipments/markAsOnHold/${userId}`, payload,Headers(auth));
export const markAsCancel  = (userId,payload,auth) => api.post(`/shipments/markAsCancel/${userId}`, payload,Headers(auth));
export const generateLabelAndPackingSlips = (userId,payload,auth) => api.post(`/shipments/generateLabelAndPackingSlips/${userId}`,payload,Headers(auth));
export const fetchLabel = (pdfName) => api.get(`/shipment/fetchLabel/${pdfName}`,{ responseType: 'blob' });
export const generateLabel = (userId,payload,auth) => api.post(`/shipment/generateLabel/${userId}`,payload,Headers(auth));
export const generateMultipleLabel = (userId,payload,auth) => api.post(`/shipments/generateMultipleLabel/${userId}`,payload,Headers(auth));
export const generateMultipleLabelAndPackingSlip = (userId,payload,auth) => api.post(`/shipments/generateMultipleLabelAndpackingSlips/${userId}`,payload,Headers(auth));
export const getShipments = (userId,status,auth) => api.get(`/shipments/${userId}/${status}`,Headers(auth));
export const getShipmentsByOrderId = (id,auth) => api.get(`/shipment/${id}`,Headers(auth));
export const getAvailableCountryForService = (countries,auth) => api.post(`/shipments/getAvailableCountry`,countries,Headers(auth));
export const updateShipmentByAdmin  = (payload,auth) => api.put(`/admin/updateShipments`,payload,Headers(auth));
export const updateMultipleShipmentsByAdmin  = (payload,auth) => api.put(`/admin/updateMultipleShipments`,payload,Headers(auth));
const apis = {
    calculateRate,
    getOAuth,
    markAsShipped,
    markAsPaid,
    markAsOnHold,
    markAsCancel,
    generateLabelAndPackingSlips,
    generateMultipleLabel,
    validateAddress,
    getAvailableCountryForService,
    getShipments,
    getShipmentsByOrderId,
    generateMultipleLabelAndPackingSlip,
    fetchLabel,
    generateLabel,
    updateShipmentByAdmin,
    updateMultipleShipmentsByAdmin
}

export default apis